// src/components/checagens/ChecagemImoveisModal.jsx
import React, { useCallback, useEffect, useState } from 'react';
import api from '../../services/api';
import './ChecagemImoveisModal.css';
import Loading from '../Loading';
import ErrorToast from '../ErrorToast';
import Toast from '../Toast';
import FiltroImoveis from '../FiltroImoveis';
import Paginacao from '../Paginacao';

const ChecagemImoveisModal = ({ checagemId, onClose, onFinish }) => {
  const [filtros, setFiltros] = useState({});
  const [imoveis, setImoveis] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState('');
  const [selected, setSelected] = useState([]);
  const [toastMsg, setToastMsg] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const pageSize = 10;

  const buscarImoveis = useCallback(async (page) => {
    setLoading(true);
    setErro('');
    try {
      const resposta = await api.get(`/imoveis`, {
        params: { ...filtros, page, pageSize }
      });
      setImoveis(resposta.data.data || []);
      setTotal(resposta.data.total || 0);
    } catch (e) {
      setErro('Erro ao buscar imóveis.');
    } finally {
      setLoading(false);
    }
  }, [filtros]);

  useEffect(() => {
    buscarImoveis(currentPage);
  }, [buscarImoveis, currentPage]);

  const handleSearch = (newFilters) => {
    setFiltros(newFilters);
    setCurrentPage(1);
  };

  const handleSelect = (id) => {
    setSelected(prev => prev.includes(id) ? prev.filter(x => x !== id) : [...prev, id]);
  };

  const handleSelectAll = async () => {
    if (total > 1000) {
      setErro("A seleção total é limitada a 1000 imóveis.");
      return;
    }
    setLoading(true);
    try {
      const resposta = await api.get(`/imoveis`, {
        params: { ...filtros, page: 1, pageSize: total }
      });
      const allIds = resposta.data.data.map(imovel => imovel.id);
      setSelected(allIds);
    } catch (e) {
      setErro("Erro ao buscar todos os imóveis.");
    } finally {
      setLoading(false);
    }
  };

  const finalizar = async () => {
    try {
      await api.post(`/checagem_imoveis/batch`, {
        checagem_id: checagemId,
        imovel_ids: selected
      });
      setToastMsg(`Total de ${selected.length} imóvel(is) incluído(s).`);
      onFinish(selected);
      onClose();
    } catch (e) {
      setErro('Erro ao finalizar inclusão.');
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" style={{ width: '1200px', maxWidth: '90vw' }} onClick={e => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose}>×</button>
        <h2 className="modal-title">Incluir Imóveis na Checagem</h2>
        <FiltroImoveis onSearch={handleSearch} />
        {erro && <ErrorToast message={erro} onClose={() => setErro('')} />}
        {loading ? (
          <Loading />
        ) : (
          <div className="imoveis-preview">
            <p>Total de imóveis encontrados: {total}</p>
            <button onClick={handleSelectAll} className="button">Selecionar Todos</button>
            <table className="preview-table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Endereço</th>
                  <th>Condomínio</th>
                  <th>Selecionar</th>
                </tr>
              </thead>
              <tbody>
                {imoveis.map(imovel => (
                  <tr key={imovel.id}>
                    <td>{imovel.id}</td>
                    <td>{imovel.logradouro}, {imovel.numero}</td>
                    <td>{imovel.condominio ? imovel.condominio.nome : '-'}</td>
                    <td>
                      <input
                        type="checkbox"
                        checked={selected.includes(imovel.id)}
                        onChange={() => handleSelect(imovel.id)}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            <Paginacao
              paginaAtual={currentPage}
              totalItens={total}
              itensPorPagina={pageSize}
              setPaginaAtual={handlePageChange}
            />
          </div>
        )}
        <div className="finalizar-section">
          <p>Total de imóveis selecionados: {selected.length}</p>
          <button className="button" onClick={finalizar} disabled={selected.length === 0}>Finalizar Inclusão</button>
        </div>
        {toastMsg && <Toast message={toastMsg} onClose={() => setToastMsg('')} />}
      </div>
    </div>
  );
};

export default ChecagemImoveisModal;
